import { Component, ElementRef } from '@angular/core'
import { Router } from '@angular/router'

import { AuthService, LocalizeService } from '../../insa-services'
import { SharedMethodsModule } from '../../insa-custom-scripts'

@Component({
  templateUrl: 'forgotPassword.component.html'
})
export class ForgotPasswordComponent {
  username: string = "";
  submitted: boolean = false;

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _localize: LocalizeService,
    private _element: ElementRef,
  ) { }

  cancel() {
    this._router.navigate(['/login']);
  }

  onSubmit(form: any): void {
    this.submitted = true;
    kendo.ui.progress($(".main-loading"), true);

    // requestPasswordReset() itself navigates to whichever 2FA verifier
    // (twoFactorValidate / twoFactorCertificate / twoFactorSetup-blocked)
    // applies to this username - same routing AuthService.login() already
    // does for the preauth branch. Note: per backend contract, this call
    // should behave identically whether or not the username exists, to
    // avoid leaking which usernames are valid.
    this._authService.requestPasswordReset(form['username']);
  }

  ngAfterViewInit() {
    this._localize.applyTranslations(this._element.nativeElement, 'LOOKUP');
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-login/forgotPassword.component.ts